<template>
  <div>
    <div class="side-head">
      <h2>{{ shortenName(product.park_name, airport.airport_name) }}</h2>
      <h6>{{ airport.airport_name }} {{ $t('banner.airport') }}</h6>
      <span class="info-link text-uppercase">
        <span @click="moreInfo = product">
          <i class="icon-add"></i>
          {{ $t('payment.basket.more_info') }}
        </span>
      </span>
    </div>
    <div class="wrap">
      <div class="side-img">
        <img 
          :src="`https://s3-eu-west-1.amazonaws.com/skyassets/resources/carpark_logos/${product.product_id}_241_121.png`" 
          :alt="product.park_name" 
          class="mb-1"
        />
        <a 
          v-if="product.product_tcs"
          :href="`https://legacy.skyparksecure.com/product-terms/${product.product_tcs}`" 
          target="_blank">
            <small>{{ $t('payment.basket.car_terms') }}</small>
        </a>
      </div>
      <div class="holder">
        <div class="info-detail">
          <span class="text">
            <span class="title">{{ $t('payment.basket.from') }}</span>
            {{ dateAtTime(quote.dateA, quote.timeA) }}
          </span>
          <span class="text">
            <span class="title">{{ $t('payment.basket.to') }}</span>  
            {{ dateAtTime(quote.dateB, quote.timeB) }}
          </span>
          <span class="edit">
            <a nohref @click="editTimes = !editTimes">
              {{ $t(`payment.basket.${editTimes ? 'edit_cancel' : 'edit'}`) }}
            </a>
          </span>
          <div class="price-info">
            <div class="price-wrap">
              <strong class="price" v-if="product.price">{{ currency }}{{ parseFloat(product.price).toFixed(2) }}</strong>
              <span v-if="parseFloat(product.discount) > 0" class="old-price">{{ currency }}{{ product.full_price }}</span>
              <strong v-if="vehicles.length > 1" class="vehicles">x{{ vehicles.length }}</strong>
            </div>
            <div class="multi-car">
              <span></span>
            </div>
            <span v-if="product.discount > 0" class="save-btn mt-2">
              <span v-if="product.discount_percent > 0">
                {{ product.discount_percent }}% 
                {{ $t('airportparking.results.product.cheaper_discount') }}
                {{ currency }}{{ product.discount }}
              </span>
              <span v-else>{{ $t('airportparking.results.product.cheaper_discount_saving') }} {{ currency }}{{ product.discount }}</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sync, get } from "vuex-pathify";
import mixins from "@/mixins";

export default {
  name: "basket-parking-item",
  mixins: [mixins.format, mixins.globals],
  props: {
    product: { required: true, default: () => {} },
    quote: { required: true, default: () => {} }
  },
  computed: {
    airport: get("results/airport"),
    vehicles: sync("payment/vehicles"),
    moreInfo: sync("modals/moreInfo"),
    editTimes: sync("payment/editTimes")
  }
};
</script>